var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{class:_vm.classes},_vm._l((_vm.blok.accordion_items),function(item){return _c(_vm.dashify(item.component),{key:item._uid,tag:"component",attrs:{"blok":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }